/**
 * Event sign-up form (templates/page.liquid, Velle Experience, Cycling card).
 *
 * <s-event-signup> wraps a native form that posts to /cart/add with return_to=/checkout.
 * Each class radio carries data-pay-id (the class variant, which holds the seats). "Pay on the day"
 * carries data-return (/discount/CODE?redirect=/checkout) so the 100 % code is applied. The size list follows the
 * chosen piece (data-sizes on each piece radio, comma-separated).
 */
class EventSignup extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.idInput = this.querySelector('input[name="id"]');
    this.sizeSelect = this.querySelector('select[data-size]');
    this.error = this.querySelector('[data-signup-error]');
    this.querySelectorAll('input[data-sizes]').forEach((input) => {
      input.addEventListener('change', () => this.fillSizes(input));
    });
    const checkedPiece = this.querySelector('input[data-sizes]:checked');
    if (checkedPiece) this.fillSizes(checkedPiece);
    this.form?.addEventListener('submit', (event) => this.pickVariant(event));
  }

  fillSizes(piece) {
    if (!this.sizeSelect) return;
    const current = this.sizeSelect.value;
    const sizes = (piece.dataset.sizes || '').split(',').filter(Boolean);
    this.sizeSelect.replaceChildren(
      ...sizes.map((size) => {
        const option = document.createElement('option');
        option.value = size;
        option.textContent = size;
        option.selected = size === current;
        return option;
      })
    );
  }

  pickVariant(event) {
    const slot = this.form.querySelector('input[data-pay-id]:checked');
    const payment = this.form.querySelector('input[name="properties[Pagamento]"]:checked');
    const id = slot?.dataset.payId;
    if (!slot || !id || !payment) {
      event.preventDefault();
      if (this.error) this.error.hidden = false;
      return;
    }
    if (this.error) this.error.hidden = true;
    this.idInput.value = id;
    const returnTo = this.form.querySelector('input[name="return_to"]');
    if (returnTo) returnTo.value = payment.dataset.return || '/checkout';
  }
}

if (!customElements.get('s-event-signup')) customElements.define('s-event-signup', EventSignup);
